<template>
    <div class="section" id="loaderPage">
        <div class="kinetic"></div>
    </div>
</template>
<style>
#loaderPage {
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: coral;
}
.kinetic {
    position: relative;
    height: 80px;
    width: 80px;
}

.kinetic::after,
.kinetic::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border: 50px solid transparent;
    border-bottom-color: #313633;
    animation: rotateA 2s linear infinite .5s;
}

.kinetic::before {
    transform: rotate(90deg);
    animation: rotateB 2s linear infinite;
}

@keyframes rotateA {
    0%, 25% {
        transform: rotate(0deg);
    }

    50%, 75% {
        transform: rotate(180deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes rotateB {
    0%, 25% {
        transform: rotate(90deg);
    }

    50%, 75% {
        transform: rotate(270deg);
    }

    100% {
        transform: rotate(450deg);
    }
}
</style>
<script>
import $ from 'jquery'
export default {
    name : 'LoaderPage',
    mounted(){
$(window).on('load',()=>{
    $('#loaderPage').fadeOut('slow')
})
    }
}

</script>